import { LOCAL_STORAGE_KEY } from '../constants';

function decodeJwt(jwt: string) {
  const claimStr = jwt.split('.')[1];
  const decoded = base64urlDecode(claimStr);
  return JSON.parse(decoded);
}

function base64urlDecode(input: string) {
  // Replace non-url compatible chars with base64 standard chars
  const escaped = input.replace(/-/g, '+').replace(/_/g, '/');
  // Pad out with standard base64 required padding characters
  const pad = escaped.length % 4;
  if (pad) {
    if (pad === 1) {
      throw new Error(
        'InvalidLengthError: Input base64url string is the wrong length to determine padding',
      );
    }
    input += new Array(5 - pad).join('=');
  }
  return atob(input);
}

function isExistScope(scope: string, jwt: string) {
  const claim = decodeJwt(jwt);
  const userScopes: string[] = claim.scp || [];
  return userScopes.includes(scope);
}

function getAccessTokenFromLocalStorage() {
  const jwtExpireTs = localStorage.getItem(
    LOCAL_STORAGE_KEY.USER_JWT_EXPIRE_TS,
  );
  const expired = jwtExpireTs ? Date.now() > parseInt(jwtExpireTs) : true;

  if (expired) return null;
  return localStorage.getItem(LOCAL_STORAGE_KEY.USER_JWT);
}

function saveAccessTokenToLocalStorage(jwt: string, expires_in_secs: number) {
  localStorage.setItem(LOCAL_STORAGE_KEY.USER_JWT, jwt);
  localStorage.setItem(
    LOCAL_STORAGE_KEY.USER_JWT_EXPIRE_TS,
    String(Date.now() + expires_in_secs * 1000),
  );
}

function clearUserToken() {
  localStorage.removeItem(LOCAL_STORAGE_KEY.USER_JWT);
  localStorage.removeItem(LOCAL_STORAGE_KEY.USER_JWT_EXPIRE_TS);
}

export {
  decodeJwt,
  isExistScope,
  getAccessTokenFromLocalStorage,
  saveAccessTokenToLocalStorage,
  clearUserToken,
};
